import { MODULE_ROUTE } from "../../../routers/module-router";

export default function QuickActions() {
  const actions = [
    {
      icon: "🛒",
      title: "Tạo đơn mới",
      desc: "POS System",
      onClick: () => window.open(MODULE_ROUTE.POS_ORDER, "_blank"),
    },
    {
      icon: "👤",
      title: "Thêm khách hàng",
      desc: "Khách hàng mới",
      onClick: () => window.open(MODULE_ROUTE.CUSTOMER, "_blank"),
    },
    {
      icon: "⚙️",
      title: "Quản lý dịch vụ",
      desc: "Giá & dịch vụ",
      onClick: () => window.open(MODULE_ROUTE.SERVICE_MAP_LIST, "_blank"),
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4">Thao tác nhanh</h3>
      <div className="space-y-3">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            className="flex items-center gap-4 w-full p-4 border border-gray-200 rounded-lg cursor-pointer transition-all duration-300 text-left text-gray-900 hover:border-indigo-500 hover:bg-gray-50"
          >
            <div className="text-xl p-4 rounded-xl bg-gray-100">
              {action.icon}
            </div>
            <div className="text-left">
              <div className="font-medium text-gray-900">{action.title}</div>
              <div className="text-sm text-gray-500">{action.desc}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
